<template>
  <div class="epidemic">
    <div class="box">
      <div class="title"></div>
      <div class="part1">
        <div class="sub-title"><span>哪些东西不能带？</span></div>
        <div class="goods fx-row fx-m-between">
          <div>医用酒精</div>
          <div>散装白酒</div>
          <div>水果刀</div>
          <div>猫猫狗狗</div>
        </div>
        <div class="tips split">
          <div class="fx-row" @click="gotoTrainRule">
            <div class="info fx-1 fx-col fx-h-center">
              <div class="txt stop">最全火车违禁品清单</div>
              <div class="desc">注意！这些东西不能带上火车</div>
            </div>
            <div class="check">点击查看</div>
          </div>
        </div>
      </div>

      <div class="part2">
        <div class="sub-title max"><span>乘火车如何做好个人防护？</span></div>
        <div class="list">
          <div class="item" v-for="(item, i) of trainTips" :key="i">{{item}}</div>
        </div>

        <div class="tips bottom" v-if="!isLbyh">
          <div class="fx-row" @click="gotoTrainRestRoom">
            <div class="info fx-1 fx-col fx-h-center">
              <div class="txt">高铁休闲室</div>
              <div class="desc">免费领取口罩、手套、消毒湿巾</div>
            </div>
            <div class="check">点击了解</div>
          </div>
        </div>

        <div v-else style="height: 30px"></div>
      </div>
    </div>

    <div class="box flight" v-if="!isLbyh">
      <div class="title"></div>
      <div class="part1">
        <div class="sub-title"><span>哪些东西不能带？</span></div>
        <div class="goods fx-row fx-m-between">
          <div>医用酒精</div>
          <div>散装白酒</div>
          <div>水果刀</div>
          <div>猫猫狗狗</div>
        </div>
        <div class="tips split">
          <div class="fx-row" @click="gotoFlightRule">
            <div class="info fx-1 fx-col fx-h-center">
              <div class="txt stop">最全飞机违禁品清单</div>
              <div class="desc">注意！这些东西不能带上飞机</div>
            </div>
            <div class="check">点击查看</div>
          </div>
        </div>
      </div>

      <div class="part2">
        <div class="sub-title max"><span>乘飞机如何做好个人防护？</span></div>
        <div class="list">
          <div class="item" v-for="(item, i) of flightTips" :key="i">{{item}}</div>
        </div>

        <div class="tips bottom">
          <div class="fx-row" @click="gotoFlightRestRoom">
            <div class="info fx-1 fx-col fx-h-center">
              <div class="txt">机场贵宾厅</div>
              <div class="desc">VIP会员休息室，贵宾候机体验</div>
            </div>
            <div class="check">点击了解</div>
          </div>
        </div>
      </div>
    </div>

    <div class="iphone-x"></div>

    <div class="share" v-if="isLbyh && !isLbyhShare" @click="setShowShare(true)">
      分 享
    </div>

    <share :is-show="isShowShare" @close="setShowShare" @show="setShowShare" v-if="!isLbyh"></share>
  </div>
</template>

<script>
  import nativeApi from '@/utils/native-api'
  import env from '@/utils/env'
  //component
  import Share from './components/share'
  //service
  import service from '../service'

  const trainTips = [
    '提前了解目的地的疫情形势和防控政策，暂缓前往中高风险地区；',
    '尽可能地错峰出行，避开春节前后的高峰；',
    '遵守排队秩序，保持安全距离；',
    '全程佩戴口罩，注意手部清洁消毒；',
    '配合列车乘务员进行体温测量；',
    '减少在车上的用餐次数，尽量少上厕所；',
    '尽可能少接触公共区域、少走动；',
    '尽量以刷卡、扫码等无接触方式购票，并自助扫码进站；',
    '如有发热、干咳、乏力等不适症状，立即向工作人员需求帮助。'
  ]

  const flightTips = [
    '提前关注航班信息，在旅行途中做好个人防护，全程佩戴口罩，非必要情况下不要摘口罩；',
    '尽量使用手机App自主值机和扫码登记，减少接触；',
    '做好手部的清洁消毒。在机场的公共区域，如登机口等很多地方均提供了手部清洁消毒产品，可以配合使用；',
    '如果在机场或者航班上感觉有发热、干咳、乏力这些不适症状，要立即向机场工作人员或乘务员寻求帮助；',
    '使用机上盥洗室时，避免多人长时间等候；用后冲水时要注意先关闭马桶盖再冲水，以减少相应风险。'
  ]

  const routes = {
    'trainRule': 'https://cdn.133.cn/gtgj/html/article/2020/12/1606876295418.html?tintColor=255,255,255&tintColorStyle=1&statusBarStyle=1',
    'trainRestRoom': 'https://h5.133.cn/hangban/vue/paidService/cipHome?type=train',
    'flightRule': 'https://cdn.133.cn/gtgj/html/article/2021/01/1609814787974.html?tintColor=255,255,255&tintColorStyle=1&statusBarStyle=1',
    'flightRestRoom': 'https://h5.133.cn/hangban/vue/paidService/cipHome?type=airport',
    'epidemicDetails': 'festivalActivity/epidemic-details'
  }

  export default {
    data() {
      return {
        trainTips,
        flightTips,
        isShowShare: false,
        //是否宁波银行
        isLbyh: false,
        isLbyhShare: false
      };
    },
    components: {
      Share
    },
    methods: {
      gotoTrainRule() {
        //宁波银行
        if (this.isLbyh) {
          this.$router.push({
            name: routes.epidemicDetails
          })
        } else {
          gotoPage('trainRule')
        }
      },
      gotoTrainRestRoom() {
        gotoPage('trainRestRoom')
      },
      gotoFlightRule() {
        gotoPage('flightRule')
      },
      gotoFlightRestRoom() {
        gotoPage('flightRestRoom')
      },
      setShowShare(val) {
        if (this.isLbyh && val) {
          lbyhSharePages()
        } else {
          this.isShowShare = val
        }
      }
    },
    created() {
      this.isLbyh = this.$route.query.lbyh == 1
      this.isLbyhShare = this.$route.query.lbyhShare == 1

      service.eventTrack({eventId: 'epidemic', eventType: 'expose'})
    }
  }

  function gotoPage(name) {
    let path = routes[name]

    if (path) {
      if (env.isNative) {
        nativeApi.invoke('createWebView', {url: path})
      } else {
        location.href = path
      }
    }
  }

  function lbyhSharePages() {
    let config = {
      type: 'WX,PYQ', // 分享渠道； WX-微信，PYQ-朋友圈
      title: '注意！这些东西不能带上火车，小心被没收！', // 分享标题
      content: '春运出行，安全到家', // 分享摘要
      hrefUrl: 'https://h5.133.cn/gtgjwap/h5/festivalActivity/epidemic?lbyh=1&lbyhShare=1', // 分享页面url全路径地址
      imgUrl: 'https://cdn.133.cn/gtgjwap/Image/festivalActivity/epidemic/share-pyq.png', // 分享图标url全路径地址
    };
    let callback = function () {
    }

    //eslint-disable-next-line
    PLUTO.sharePages(config, callback);
  }
</script>

<style lang="scss" scoped>
  @import "../style/mixin";

  .epidemic {
    padding-top: pxTo(287);
    padding-bottom: pxTo(36+52+50);

    background-image: url($imgUrl + 'banner2.jpg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: top center;
    background-color: $c1;

    .box {
      margin: 0 pxTo(20);

      .title {
        &::before, &::after {
          content: '';
          display: block;
          margin: 0;
        }

        &::before {
          height: pxTo(42);
          @include bg($imgUrl, 'train');
          background-size: 100% 100%;
        }

        &::after {
          height: pxTo(7);
          @include bg($imgUrl, 'train-title-bottom');
          background-size: 100% 100%;
        }
      }

      .sub-title {
        width: pxTo(131);
        height: pxTo(19);
        display: inline-block;
        position: relative;
        margin: 0 pxTo(18);

        &.max {
          width: pxTo(195);
        }

        > span {
          height: pxTo(16);
          z-index: 1;
          position: absolute;
          top: 0;
          left: pxTo(3);

          @extend %no-break;
          @include fs-l-w-c(16, 16, 500, $c3);
        }

        &::before {
          content: '';
          width: 90%;
          height: pxTo(8);
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;

          background-color: $c4;
        }

        &::after {
          content: '';
          width: 90%;
          height: pxTo(8);
          display: block;
          position: absolute;
          bottom: 0;
          right: 0;

          @include bg($imgUrl, 'train-title');
          background-size: pxTo(131) pxTo(8);
          background-position: top right;
        }
      }

      .goods {
        margin: 0 pxTo(18);
        margin-top: pxTo(16);

        > div {
          width: pxTo(54);
          padding-top: pxTo(54+8);
          text-align: center;
          background-size: 100% auto !important;
          background-position: top center !important;

          @extend %no-break;
          @include fs-l-w-c(13, 13, 400, $c5);

          &:nth-of-type(1) {
            @include bg($imgUrl, 'train1');
          }

          &:nth-of-type(2) {
            @include bg($imgUrl, 'train2');
          }

          &:nth-of-type(3) {
            @include bg($imgUrl, 'train3');
          }

          &:nth-of-type(4) {
            @include bg($imgUrl, 'train4');
          }
        }
      }

      .tips {
        height: pxTo(69);
        margin-top: pxTo(25);
        position: relative;

        &.split {
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: pxTo(15);
            position: absolute;
            left: 0;
            bottom: pxTo(-7);

            @include bg($imgUrl, 'train-title-bg');
            background-size: 100% 100%;
            background-color: $c1;
          }
        }

        &.bottom {
          .info {
            border-bottom-left-radius: pxTo(8);
          }

          .check {
            border-bottom-right-radius: pxTo(8);
          }
        }

        .info {
          height: pxTo(69);
          padding-left: pxTo(16);
          background-color: $c4;

          .txt {
            height: pxTo(16);

            @include fs-l-w-c(16, 16, 500, $c3);

            &.stop {
              padding-left: pxTo(20);

              @include bg($imgUrl, 'stop');
              background-size: pxTo(15) pxTo(16);
              background-position: left center;
            }
          }

          .desc {
            height: pxTo(13);
            margin-top: pxTo(8);

            @include fs-l-w-c(13, 13, 400, $c7);
          }
        }

        .check {
          width: pxTo(105);
          text-align: center;
          background-color: $c6;

          @include fs-l-w-c(13, 69, 400, $c3);
        }
      }

      .list {
        margin: 0 pxTo(16);

        > div {
          border-bottom: 1px solid rgba(48, 66, 195, .3);

          &:nth-last-of-type(1) {
            border: 0 !important;
            padding-bottom: 0 !important;
          }
        }

        .item {
          position: relative;
          padding: pxTo(10) 0 pxTo(10) pxTo(15);

          @include fs-l-w-c(13, 18, 400, $c3);

          &::before {
            content: '';
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background-color: $c4;
            position: absolute;
            left: 0;
            top: pxTo(16);
          }
        }
      }

      .part1 {
        background-color: $c2;
        padding: pxTo(17) 0 0 0;
      }

      .part2 {
        background-color: $c2;
        padding: pxTo(23) 0 0 0;

        border-bottom-right-radius: pxTo(8);
        border-bottom-left-radius: pxTo(8);
      }

      &.flight {
        margin-top: pxTo(24);

        .title {
          &::before {
            @include bg($imgUrl, 'flight');
            background-size: 100% 100%;
          }

          &::after {
            @include bg($imgUrl, 'flight-title-bottom');
            background-size: 100% 100%;
          }
        }

        .sub-title {
          &::before {
            background-color: $c9;
          }

          &::after {
            @include bg($imgUrl, 'flight-title');
            background-size: pxTo(131) pxTo(8);
            background-position: top right;
          }
        }

        .goods {
          > div {
            @include fs-l-w-c(13, 13, 400, $c13);
          }
        }

        .tips {
          &.split {
            &::after {
              @include bg($imgUrl, 'flight-title-bg');
              background-size: 100% 100%;
              background-color: $c1;
            }
          }

          .info {
            background-color: $c10;

            .desc {
              @include fs-l-w-c(13, 13, 400, $c12);
            }
          }

          .check {
            background-color: $c11;
          }
        }

        .list {
          > div {
            border-bottom: 1px solid rgba(75, 53, 154, .3);
          }

          .item {
            &::before {
              background-color: $c10;
            }
          }
        }

        .part1 {
          background-color: $c8;
        }

        .part2 {
          background-color: $c8;
        }
      }
    }
  }

  .share {
    width: pxTo(335);
    height: pxTo(50);
    background-color: $c5;
    border-radius: pxTo(30);
    position: fixed;
    bottom: pxTo(40);
    z-index: 1;
    text-align: center;

    @include fs-l-w-c(16, 50, 500, $c3);
    @extend %h-center;
  }
</style>



// WEBPACK FOOTER //
// src/projects/festivalActivity/epidemic/pages/index.vue